
import knowledgecheck from '@/components/pages/admin/knowledge-checks/edit.vue'
import knowledgecheckPreview from '@/components/pages/admin/knowledge-checks/preview.vue'
import componentKnowledgeCheckCreate from '@/components/pages/admin/knowledge-checks/components/create.vue'
import componentKnowledgeCheck from '@/components/pages/admin/knowledge-checks/components/index.vue'
import componentKnowledgeCheckPreview from '@/components/pages/admin/knowledge-checks/components/preview.vue'
import clientIndex from '@/components/pages/client/knowledge-checks/index.vue'
import clientComponentIndex from '@/components/pages/client/knowledge-checks/component-index.vue'
import clientShow from '@/components/pages/client/knowledge-checks/show.vue'

import reports from '@/components/pages/admin/knowledge-checks/reports/index.vue'
import reportResponseDetail from '@/components/pages/admin/knowledge-checks/reports/response-detail/index.vue'

import print from '@/components/pages/admin/knowledge-checks/print/index'

const routes = [
  // Report Routes
  {
    path: '/:organization/admin/reports/knowledgecheck',
    name: 'admin-reports-knowledgecheck',
    component: reports,
    meta: {
      auth: true,
      admin: true
    }
  },
  {
    path: '/:organization/admin/reports/knowledgecheck/:responseId',
    name: 'admin-reports-knowledgecheck-response-detail',
    component: reportResponseDetail,
    meta:{
      auth: true,
      admin: true
    }
  },

  // Topic Routes
  {
    path: '/:organization/admin/modules/:module/components/:component/topics/:topic/knowledgecheck',
    name: 'admin-knowledgecheck',
    component: knowledgecheck,
    meta: {
      auth: true,
      admin: true
    }
  },
  {
    path: '/:organization/admin/modules/:module/components/:component/topics/:topic/knowledgecheck/:id/preview',
    name: 'admin-knowledgecheck-preview',
    component: knowledgecheckPreview,
    meta: {
      auth: true,
      admin: true
    }
  },

  // Component Routes
  {
    path: '/:organization/admin/modules/:module/components/:component/knowledgecheck/create',
    name: 'admin-component-knowledgecheck-create',
    component: componentKnowledgeCheckCreate,
    meta: {
      auth: true,
      admin: true
    }
  },
  {
    path: '/:organization/admin/modules/:module/components/:component/knowledgecheck',
    name: 'admin-component-knowledgecheck',
    component: componentKnowledgeCheck,
    meta: {
      auth: true,
      admin: true
    }
  },
  {
    path: '/:organization/admin/modules/:module/components/:component/knowledgecheck/:id/preview',
    name: 'admin-component-knowledgecheck-preview',
    component: componentKnowledgeCheckPreview,
    meta: {
      auth: true,
      admin: true
    }
  },
  {
    path: '/:organization/admin/modules/:module/knowledgecheck/:id/print/:number?',
    name: 'admin-knowledgecheck-print',
    component: print,
    meta: {
      auth: true,
      admin: true
    }
  },

  // Client Routes
  {
    path: '/:organization/modules/:module/components/:component/topics/:topic/knowledgecheck/:knowledgecheckId',
    name: 'client-knowledgecheck',
    component: clientIndex,
    meta: {
      auth: true
    }
  },
  {
    path: '/:organization/modules/:module/components/:component/topics/:topic/knowledgecheck/:knowledgecheckId/response/:responseId',
    name: 'client-knowledgecheck-response-show',
    component: clientShow,
    meta: {
      auth: true
    }
  },
  {
    path: '/:organization/modules/:module/components/:component/knowledgecheck/:knowledgecheckId',
    name: 'client-component-knowledgecheck',
    component: clientComponentIndex,
    meta: {
      auth: true
    }
  },
  {
    path: '/:organization/modules/:module/components/:component/knowledgecheck/:knowledgecheckId/response/:responseId',
    name: 'client-component-knowledgecheck-response-show',
    component: clientShow,
    meta: {
      auth: true
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/modules/knowledgechecks.js